<template>
  <div id="footer" class="container-fluid">
    <p class="title">颐守（evsoul）</p>
    <p class="address_tel_fax">
      <span>AI赋能精准医疗，科技守护生命之光</span>
    </p>
    <p class="record-info">
      <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2026041467号-1</a>
    </p>
    <p class="gongan-record">
      <a href="http://www.beian.gov.cn/portal/index" target="_blank">
        京公网安备11011402056633号
      </a>
    </p>
    <p class="copy">Copyright &copy; 2026 北京颐守智能科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  padding: 60px 15px 30px;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.title {
  font-size: 25px;
  margin-bottom: 24px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 12px 0;
}
.record-info {
  color: #d3d3d3;
  font-size: 14px;
  margin: 12px 0;
}
.record-info a {
  color: #d3d3d3;
  text-decoration: none;
}
.record-info a:hover {
  color: #ffffff;
}
.gongan-record {
  color: #d3d3d3;
  font-size: 14px;
  margin: 12px 0;
}
.gongan-record a {
  color: #d3d3d3;
  text-decoration: none;
}
.gongan-record a:hover {
  color: #ffffff;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 30px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .record-info {
    font-size: 12px;
  }
  .gongan-record {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 20px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue